import { Table } from "antd";
import Modal from "../../../components/generic/Modal";
import { useBranchEmails } from "../../../hooks/useBranchEmails";
import { useMemo } from "react";

const EmailRulesModal = ({ onCancel, selectedBranch, topics }) => {
  const { loading, emails } = useBranchEmails(selectedBranch?.id);

  const formattedEmails = useMemo(() => {
    const topicMap = Object.fromEntries(
      topics.map(({ id, name }) => [id, name]),
    );

    return emails.map((email) => ({
      ...email,
      topic_name: topicMap[email?.topic_id],
    }));
  }, [topics, emails]);

  const columns = useMemo(
    () => [
      {
        title: "Username",
        dataIndex: "username",
        key: "username",
      },
      {
        title: "Display Name",
        dataIndex: "display_name",
        key: "display_name",
      },
      {
        title: "Topic",
        dataIndex: "topic_name",
        key: "topic_name",
      },
      {
        title: "First Name",
        dataIndex: "first_name",
        key: "first_name",
      },
      {
        title: "Last Name",
        dataIndex: "last_name",
        key: "last_name",
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        render: (value) => new Date(value).toLocaleString(),
      },
    ],
    [],
  );

  return (
    <Modal
      isProcessing={loading}
      title={`Email Routings - ${selectedBranch?.name}`}
      onCancel={onCancel}
      width={"100%"}
      open
      footer={null}
    >
      <Table
        rowKey="id"
        columns={columns}
        dataSource={formattedEmails}
        loading={loading}
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};

export default EmailRulesModal;
